export interface TimesheetSetup {
  CustomField: CustomField[];
  CustomFieldType: CustomFieldTypes;
  CustomFieldData: CustomFieldData;
  ServerTime: ServerTime;
  LocationSettings: LocationSettings;
  Permissions: string[];
}

export interface CustomField {
  Id: number;
  System: string;
  Name: string;
  ApiName: string;
  DeputyField: string;
  SortOrder: any;
  Default: string | string[] | boolean;
  Type: number;
  DisplayTiming: DisplayTiming;
  ConditionalRules: any;
  Action: any;
  Published: number;
  Valuelist: string[];
  Visible: boolean;
  TriggerScript: number;
  Validation: string[];
  Helptext: string;
  Creator: number;
  Created: string;
  Modified: string;
  _DPMetaData: DpmetaData;
  StrType: string;
  OperationalUnits: number[];
}

export enum DisplayTiming {
  ClockOutAndUpdate = 1,
  ClockIn = 2,
  ClockInClockOutAndUpdate = 3,
}

export interface DpmetaData {
  System: string;
  CreatorInfo: CreatorInfo;
}

export interface CreatorInfo {
  Id: number;
  DisplayName: string;
  EmployeeProfile: number;
  Employee: number;
  Photo: string;
  Pronouns: number;
  CustomPronouns: string;
}

export interface CustomFieldTypes {
  '1': CustomFieldTypeValues;
  '2': CustomFieldTypeValues;
  '3': CustomFieldTypeValues;
  '4': CustomFieldTypeValues;
  '5': CustomFieldTypeValues;
  '6': CustomFieldTypeValues;
  '7': CustomFieldTypeValues;
  '8': CustomFieldTypeValues;
  '9': CustomFieldTypeValues;
}

export type CustomFieldTypeValues =
  | 'text'
  | 'number'
  | 'large-text'
  | 'boolean-checkbox'
  | 'list'
  | 'multi-list'
  | 'file'
  | 'boolean-checkbox-yes-with-comment-required'
  | 'boolean-checkbox-no-with-comment-required';

export enum CustomFieldType {
  Text = 'text',
  Number = 'number',
  LargeText = 'large-text',
  BooleanCheckbox = 'boolean-checkbox',
  List = 'list',
  MultiList = 'multi-list',
  File = 'file',
  BooleanCheckboxYesWithComment = 'boolean-checkbox-yes-with-comment-required',
  BooleanCheckboxNoWithComment = 'boolean-checkbox-no-with-comment-required',
}

export interface CustomFieldData {
  Id: number;
  System: string;
  Creator: number;
  Created: string;
  Modified: string;
  _DPMetaData: DpmetaData;
  [key: string]: string | string[] | number | boolean | DpmetaData;
}

export interface ServerTime {
  date: string;
  time: string;
  datetime: string;
  unixtime: number;
  day_timestamp: string;
  timezone: string;
  formats: Formats;
}

export interface Formats {
  SHORT_DATE_FORMAT: string;
  LONG_DATE_FORMAT: string;
  SHORT_TIME_FORMAT: string;
  LONG_TIME_FORMAT: string;
}

export interface LocationSettings {
  TIMEZONE: string;
  SYSTEM_LOCALE: string;
  WEEK_START: string;
  ACTIVE_HOURS_START: string;
  ROSTER_DEFAULT_SHIFT_LEN: string;
  DEFAULT_MEALBREAK_DURATION: string;
  ROSTER_ALLOW_PEER_VIEW: string;
  GEOFENCE_RADIUS: string;
  ROSTER_ALLOW_SWAP_SHIFT: string;
  ROSTER_SWAP_REQUIRE_APPROVAL: string;
  ROSTER_ALLOW_OFFER_SHIFT: string;
  CAN_MOBILE_BUMP_SHIFT: string;
  CAN_SUBMIT_SHIFT_VIA_DESK: string;
  CAN_MODIFY_TIMESHEET_ON_END: string;
  CAN_CLOCKIN_SHIFT_EARLIER: string;
  CAN_CLOCKIN_SHIFT_EARLIER_MINS: string;
  CAN_END_BREAK_EARLIER: string;
  CAN_BUMP_SHIFT_VIA_DESK: string;
  TIMESHEET_CLOSEST_BLOCK: string;
  MEALBREAK_IS_PAID: string;
  ALLOW_EMPS_SEE_LEAVE_BALANCE: string;
}
